export class BankSlipData {
    latePercentage = 0
    percentagePaid = 0
    openPercentage = 0
}
